// components/WelcomeBanner/WelcomeBanner.js
import React, { useState, useEffect } from 'react';
import { Snackbar, Alert, Typography, Slide } from '@mui/material';
import { getDisplayNameFromEmail } from '../../utils/userUtils';
import styles from './WelcomeBanner.module.css';

function SlideTransition(props) {
  return (
    <Slide 
      {...props} 
      direction="right" 
      mountOnEnter 
      unmountOnExit
      easing={{
        enter: 'cubic-bezier(0.34, 1.56, 0.64, 1)', // Custom easing with slight overshoot
        exit: 'cubic-bezier(0.47, 0, 0.745, 0.715)'
      }}
    />
  );
}

const WelcomeBanner = ({ userName, userEmail, showBanner = true }) => {
  const [open, setOpen] = useState(showBanner);

  useEffect(() => {
    // Only start timer if banner should be shown
    if (showBanner) {
      setOpen(true);
      // Auto close after 3 seconds
      const timer = setTimeout(() => {
        setOpen(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [showBanner]);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const displayName = userName || getDisplayNameFromEmail(userEmail);
  const welcomeMessage = `Welcome, ${displayName}`;

  return (
    <Snackbar
      open={open}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      className={styles.bannerContainer}
      sx={{ 
        maxWidth: '400px',
        width: 'auto'
      }}
      TransitionComponent={SlideTransition}
      transitionDuration={{ enter: 800, exit: 400 }}
    >
      <Alert 
        onClose={handleClose} 
        severity="info" 
        variant="standard"
        className={styles.alertRoot}
        classes={{
          message: styles.alertContent
        }}
        icon={false}
        sx={{ backgroundColor: 'transparent' }}
      >
        <div className={styles.messageContainer}>
          <div className={styles.decorativeCorner}></div>
          <Typography className={styles.userName}>{welcomeMessage}</Typography>
        </div>
      </Alert>
    </Snackbar>
  );
};

export default WelcomeBanner;
